import React from 'react';
import styles from './XComponent.module.scss';
import {IComponentProps} from './IComponentProps';
import {IComponentState} from './IComponentState';

export class XComponent<E extends HTMLElement, P extends IComponentProps = {}, S extends IComponentState = {}, SS = any> extends React.Component<P, S, SS> {
    protected className: string | undefined = styles.XComponent;
    protected reference: React.RefObject<E>;

    protected static defaultProps = {
        marginLeft: undefined,
        marginRight: undefined,
        marginTop: undefined,
        marginBottom: undefined,
        margin: undefined
    }
    public constructor(props: P) {
        super(props);
        this.className = styles.XComponent;
        this.reference = React.createRef();
    }
    public componentDidMount(): void{
        const {current} = this.reference;
        const {marginLeft, marginRight, marginTop, marginBottom, margin} = this.props;
        const ml = margin ? margin : marginLeft;
        const mr = margin ? margin : marginRight;
        const mt = margin ? margin : marginTop;
        const mb = margin ? margin : marginBottom;
        if(current) {            
            let style: string = '';
            if(ml)
                style += '--margin-left: ' + ml + ';';
            if(mr)
                style += '--margin-right: ' + mr + ';';
            if(mt)
                style += '--margin-top: ' + mt + ';';
            if(mb)
                style += '--margin-bottom: ' + mb + ';';
            current.setAttribute('style', style);
        }
    }
    public componentWillUnmount(): void{}
    
    public render(): React.ReactNode {
        return <React.Fragment/>;
    }
}
